import { type FC } from 'react'
import { useAppContext } from '../contexts/AppContext'
import { ViewMode } from '@playbooks/action-cards-utils'

const DimensionsScoresTooltip: FC = () => {
  const {
    settings: { viewMode },
    data: state,
  } = useAppContext()
  const isFunnelView = viewMode === ViewMode.FUNNEL

  return state.useScoringDimensions && !isFunnelView ? (
    <ul
      data-testid="dimensionScoreTooltip"
      className={`bg-white dark:bg-black border p-1 rounded-xl border-zinc-500 dark:text-zinc-400`}
    >
      {state.scoringDimensions?.map(dim => {
        return (
          <li key={dim.id} className={`text-[12px] flex justify-between`}>
            <span className={`font-bold`}>{dim.name}: </span>
            <span className={`ml-2.5 text-zinc-600`}>
              <span>{(dim.actual || 0).toFixed(2)}</span> / <span>{dim.score?.toFixed(2)}</span>
            </span>
          </li>
        )
      })}
    </ul>
  ) : null
}

export default DimensionsScoresTooltip
